
        import 'PeachyLogo.76fec6e.css-module'
        export default {"peachyLogo":"peachyLogo_PeachyLogo_76fec6e"}
    